import { render, staticRenderFns } from "./customs.vue?vue&type=template&id=ea99d7e6&"
import script from "./customs.vue?vue&type=script&lang=js&"
export * from "./customs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports